module.exports = __webpack_public_path__ + "static/media/padi.f613d454.png";